import LinkBase from './LinkBase'

export default LinkBase



// WEBPACK FOOTER //
// ./src/components/LinkBase/index.js